module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/evNFc7/tc-custom/9781442445451.jpg?1730520792290",
      "alt": "This image is the cover for the book Struck"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Struck\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Felicity Walker believes in true love. That’s why she applies for a gig at the matchmaking company Cupid’s Hollow. But when Felicity gets the job, she learns that she isn’t just a matchmaker...she’s a cupid! (There’s more than one of them, you know.) Armed with a hot pink, tricked-out PDA infused with the latest in cupid magic (love arrows shot through email), Felicity works to meet her quota of successful matches. But the path to love is not always a straight shot...."), _c('br'), _c('br'), _vm._v("Laugh-out-loud funny and irresistibly romantic, this delightful bind-up is ideal for fans of both romantic comedies and paranormal romance.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rhonda Stapleton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rhonda Stapleton started writing a few years ago to appease the voices in her head. She lives in northeast Ohio with her two kids and their lazy dog. Visit her website at rhondastapleton.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    S&S Books for Young Readers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0